import { CommonBaseData } from "../shared";

export class N2013InputData extends CommonBaseData {
  //法人
  public hojin: string;
  //グループ区分
  public gurupukubun: string;
  //グループコード
  public gurupukodo: string;
  //ユーザＩＤ
  public yuzaid: string;
  //処理区分
  public shorikubun: string;

  // 表示ページ数
  public hyojipejisu: number;

  // ページ行数
  public pejigyosu: number;

  //最大表示件数
  public saidaihyojikensu: number;

  // お届け先区分
  public otodokesakikubun: string;

  // お届け先
  public otodokesaki: string;

  //送り先
  public okurisaki: string;

  // 郵便番号
  public yubimbango: string;

  // 都道府県
  public todofuken: string;

  // 住所
  public jusho: string;

  // 商品区分
  public syouhinnKbn: string;

  // 検索条件
  public kensakujoken: string;

  //品番1～5
  public himban1: string;
  public himban2: string;
  public himban3: string;
  public himban4: string;
  public himban5: string;

  //結合条件
  public ketsugojoken: string;

  //柄名1～2
  public emei1: string;
  public emei2: string;

  //品番
  public himban: string;

  // ST-102 Start
  // 画面ID
  public gamenid: string;
  // ST-102 End
}



// WEBPACK FOOTER //
// ./src/app/modules/n201/n2013-input-data.ts